/** @format */
// eslint-disable-next-line check-file/filename-naming-convention -- Legacy code: do not use as an example.
import { useEffect } from 'react';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
interface WindowWithEmbedly extends Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    embedly?: any;
}

export const useEmbedlyState = (): [boolean, () => void] => {
    const hasWindow = typeof window !== 'undefined';
    const win: WindowWithEmbedly | undefined = hasWindow ? window : undefined;

    const shouldLoadEmbedlyScript =
        hasWindow && typeof win?.embedly === 'undefined';

    /**
     * Handles embedly embeds, invoking their card behaviour
     * against the DOM, looking for .embedly-card
     */
    function processEmbeds() {
        // Render any embedly cards
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- Legacy code: do not use as an example.
        win?.embedly?.('card', '.embedly-card');
    }

    useEffect(() => {
        processEmbeds();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, []);

    return [shouldLoadEmbedlyScript, processEmbeds];
};
